export const FETCH_CHECKOUT_PENDING = "FETCH_CHECKOUT_PENDING";
export const FETCH_CHECKOUT_MODAL_PENDING = "FETCH_CHECKOUT_MODAL_PENDING";
export const FETCH_CHECKOUT_REJECTED = "FETCH_CHECKOUT_REJECTED";
export const FETCH_CHECKOUT_FULFILLED = "FETCH_CHECKOUT_FULFILLED";
export const FETCH_COUNTRIES_FULFILLED = "FETCH_COUNTRIES_FULFILLED";
export const FETCH_CITIES_FULFILLED = "FETCH_CITIES_FULFILLED";
export const FETCH_TOWNSHIPS_FULFILLED = "FETCH_TOWNSHIPS_FULFILLED";
export const FETCH_DISTRICTS_FULFILLED = "FETCH_DISTRICTS_FULFILLED";
export const SEND_ADDRESS_REJECTED = "SEND_ADDRESS_REJECTED";
export const FETCH_CASH_REGISTER_REJECTED = "FETCH_CASH_REGISTER_REJECTED";
export const FETCH_SMS_FULFILLED = "FETCH_SMS_FULFILLED";
export const FETCH_GUEST_CHECKOUT_FULFILLED = "FETCH_GUEST_CHECKOUT_FULFILLED";
export const FETCH_GUEST_CHECKOUT_PENDING = "FETCH_GUEST_CHECKOUT_PENDING";
export const FETCH_GUEST_CHECKOUT_REJECTED = "FETCH_GUEST_CHECKOUT_REJECTED";
export const CLEAR_GUEST_CHECKOUT = "CLEAR_GUEST_CHECKOUT";
export const CLEAR_CUSTOMER_CHECKOUT = "CLEAR_CUSTOMER_CHECKOUT";
export const CLEAR_CHECKOUT_REDIRECT = "CLEAR_CHECKOUT_REDIRECT";

export const ADD_GIFT_BOX = "ADD_GIFT_BOX";
export const REMOVE_GIFT_BOX = "REMOVE_GIFT_BOX";

export const CASH_PAYMENT_TYPE = "cash";
export const INSTALLMENT_PAYMENT_TYPE = "installment";

export const SEND_QRCODE_EMAIL_REJECTED = "SEND_QRCODE_EMAIL_REJECTED";
export const SEND_QRCODE_EMAIL_FULFILLED = "SEND_QRCODE_EMAIL_FULFILLED";

export const SET_FALSE_THANK_YOU_PAGE = "SET_FALSE_THANK_YOU_PAGE";

export const PAGES = {
  addressSelectionPage: "AddressSelectionPage",
  cashRegisterCompletePage: "CashRegisterCompletePage",
  cashRegisterInstallmentSelectionPage: "CashRegisterInstallmentSelectionPage",
  cashRegisterPage: "CashRegisterPage",
  deliveryOptionSelectionPage: "DeliveryOptionSelectionPage",
  indexPage: "IndexPage",
  paymentOptionSelectionPage: "PaymentOptionSelectionPage",
  payOnDeliveryPage: "PayOnDeliveryPage",
  retailStoreSelectionPage: "RetailStoreSelectionPage",
  sendBarcodeSmsPage: "SendBarcodeSmsPage",
  orderNotePage: "OrderNotePage",
  shippingOptionSelectionPage: "ShippingOptionSelectionPage",
  thankYouPage: "ThankYouPage",
  redirectionPaymentSelectedPage: "RedirectionPaymentSelectedPage",
  redirectionPageCompletePage: "RedirectionPageCompletePage",
  fundsTransferChoicePage: "FundsTransferChoicePage",
  fundsTransferPage: "FundsTransferPage",
  reservationSelectionPage: "ReservationSelectionPage",
};



// WEBPACK FOOTER //
// ./src/constants/checkout.js